import { memo } from 'react';
import Image from 'next/legacy/image';
import cn from 'classnames';
import { Grid } from 'ht-styleguide';

/* styles */
import styles from './skuitemguarantee.module.scss';

type ISkuItemGuarantee = Partial<{
  classes: string;
  title: string;
  text: string;
}>;

const SkuItemGuarantee = ({
  classes = '',
  title = 'Peace of Mind Guarantee',
  text = "We're committed to your complete satisfaction with our service. If you're not 100% happy, we'll do whatever it takes to make it right.",
}: ISkuItemGuarantee) => {
  const subTitleStyles = cn('p0', styles.subTitle);
  const containerStyles = cn(styles.container, classes);

  return (
    <Grid.Fluid classes={containerStyles} dataTestId="sku-item-piece-mind-guarantee">
      <Grid.Row classes={styles.customRow}>
        <Grid.Column sm={4} md={8} lg={5}>
          <div className={styles.serviceText}>
            <div className={styles.watermark} />
            <h3 className={styles.title}> {title} </h3>
            <p className={subTitleStyles}>{text}</p>
          </div>
        </Grid.Column>
        <Grid.Column sm={4} md={8} lg={7}>
          <Image
            blurDataURL="/_nextassets_/images/peace_of_mind.jpg"
            placeholder="blur"
            quality={60}
            alt={styles.title}
            src="/_nextassets_/images/peace_of_mind.jpg"
            layout="responsive"
            className={styles.guaranteeBlockImage}
            height="568"
            width="850"
          />
        </Grid.Column>
      </Grid.Row>
    </Grid.Fluid>
  );
};

export default memo(SkuItemGuarantee);
